/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarHalfIcon16Light = forwardRef('StarHalfIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.311.9A.75.75 0 0 1 8.69.9l1.764 4.096 4.442.412a.75.75 0 0 1 .425 1.31l-3.35 2.944.98 4.352a.75.75 0 0 1-1.115.81L8 12.545l-3.835 2.277a.75.75 0 0 1-1.115-.81l.98-4.35L.68 6.717a.75.75 0 0 1 .425-1.31l4.442-.412L7.31.899Zm2.224 4.492a1 1 0 0 0 .826.6l3.863.358-2.915 2.56a1 1 0 0 0-.315.972l.853 3.785-3.336-1.98a1 1 0 0 0-.511-.14v-9.72l1.535 3.565Z" })));
});
